import 'stylesheets/flat_2016/base/index.scss';

import 'javascripts/flat_2016/index';

const importAll = (fn) => fn.keys().map(fn);
importAll(require.context('images/flat_2016', true, /\.(png|jpe?g|svg|)$/));
importAll(require.context('fonts/flat_2016', true, /\.(eot|svg|ttf|woff|woff2)$/));
